(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/router.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.Router = Backbone.Router.extend({
    routes: svs.core.data.routes,

    queryToOptions: function(query) {
      var queryString;
      var queryArray;
      var optionsArray;
      var i;
      var options = {};

      if (query) {
        queryString = query.replace('?', '');
        queryArray = queryString.split('&');
        for (i = 0; i < queryArray.length; i++) {
          optionsArray = queryArray[i].split('=');
          options[optionsArray[0]] = optionsArray[1];
        }
      }

      return options;
    },

    routeStart: function() {
      if (svs.components.revealAnimation.isRevertable()) {
        svs.components.revealAnimation.prepareRevertRevealAnimation(function() {
          svs.grassroots.app.getRegion().show(new svs.grassroots.views.Start({
            model: svs.grassroots.models.grassroots
          }));
          svs.components.revealAnimation.revertRevealAnimation();
        });
      } else {
        svs.grassroots.app.getRegion().show(new svs.grassroots.views.Start({
          model: svs.grassroots.models.grassroots
        }));
      }
    },

    routeReceivers: function() {
      this.navigate('foreningar', { trigger: false, replace: true });
    },

    routeChoose: function(query) {
      var viewOptions = this.queryToOptions(query) || {};

      if (viewOptions.add) {
        this.navigate('valj', { trigger: false, replace: true });
      }

      viewOptions.model = svs.grassroots.models.grassroots;

      svs.grassroots.app
        .getRegion()
        .show(new svs.grassroots.views.ReceiversOverview(viewOptions));
    },

    routeSearch: function(query) {
      var viewOptions = this.queryToOptions(query);
      var url;

      if (viewOptions && viewOptions.add) {
        url = '?q=' + viewOptions.q + '&qs=' + viewOptions.qs + '&qc=' + viewOptions.qc;
        this.navigate('sok' + url, { trigger: false, replace: true });
      }

      svs.grassroots.app
        .getRegion()
        .show(new svs.grassroots.views.SearchResults(viewOptions));
    },

    routePartner: function() {
      svs.grassroots.app
        .getRegion()
        .show(new svs.grassroots.views.PartnerSignup());
    },

    routeReceiver: function(id, seoInfo, query) {
      var viewOptions = this.queryToOptions(query) || {};

      if (viewOptions.add) {
        this.navigate('forening/' + id, { trigger: false, replace: true });
      }

      svs.grassroots.models.single_receiver = new svs.grassroots.models.SingleReceiver();
      svs.grassroots.models.single_receiver.url =
        svs.core.jupiter.url() +
        '/player/1/sponsorship/receiverinfo?receivers=' +
        encodeURIComponent('[' + id + ']');
      viewOptions.model = svs.grassroots.models.single_receiver;
      svs.grassroots.app
        .getRegion()
        .show(new svs.grassroots.views.SingleReceiver(viewOptions));
    },
    routeMarketing: function() {
      svs.grassroots.app
        .getRegion()
        .show(new svs.grassroots.views.Marketing());
    },
    routeResult: function(year) {
      if (svs.utils.ns.isNamespace('svs.grassroots.data.result', window)) {
        svs.grassroots.models.grassroot_result = new Backbone.Model(svs.grassroots.data.result);
        svs.grassroots.collections.grassroot_result = new Backbone.Collection(svs.grassroots.data.result.resultDetails.regions);
      } else {
        var basePath = '/images/grassroots-shared/' + year + '/';
        svs.grassroots.models.grassroot_result = new Backbone.Model({
          year: year,
          overview: {
            overviewUrl: '/images/grassroots-shared/' + year + '/sverige.png'
          },
          completeResult: {
            completeDocumentUrl:
              '/documents/grassroots-shared/' +
              year +
              '/grasrotens-resultat-' +
              year +
              '.pdf'
          }
        });
        svs.grassroots.collections.grassroot_result = new Backbone.Collection([
          {
            region: 'Blekinge',
            id: 'blekinge',
            imgUrl: basePath + 'blekinge.png'
          },
          {
            region: 'Dalarna',
            id: 'dalarna',
            imgUrl: basePath + 'dalarna.png'
          },
          {
            region: 'Gävleborg',
            id: 'gavleborg',
            imgUrl: basePath + 'gavleborg.png'
          },
          {
            region: 'Gotland',
            id: 'gotland',
            imgUrl: basePath + 'gotland.png'
          },
          {
            region: 'Halland',
            id: 'halland',
            imgUrl: basePath + 'halland.png'
          },
          {
            region: 'Jämtland',
            id: 'jamtland',
            imgUrl: basePath + 'jamtland.png'
          },
          {
            region: 'Jönköping',
            id: 'jonkoping',
            imgUrl: basePath + 'jonkoping.png'
          },
          {
            region: 'Kalmar',
            id: 'kalmar',
            imgUrl: basePath + 'kalmar.png'
          },
          {
            region: 'Kronoberg',
            id: 'kronoberg',
            imgUrl: basePath + 'kronoberg.png'
          },
          {
            region: 'Norrbotten',
            id: 'norrbotten',
            imgUrl: basePath + 'norrbotten.png'
          },
          {
            region: 'Skåne',
            id: 'skane',
            imgUrl: basePath + 'skane.png'
          },
          {
            region: 'Stockholm',
            id: 'stockholm',
            imgUrl: basePath + 'stockholm.png'
          },
          {
            region: 'Södermanland',
            id: 'sodermanland',
            imgUrl: basePath + 'sodermanland.png'
          },
          {
            region: 'Uppsala',
            id: 'uppsala',
            imgUrl: basePath + 'uppsala.png'
          },
          {
            region: 'Värmland',
            id: 'varmland',
            imgUrl: basePath + 'varmland.png'
          },
          {
            region: 'Västerbotten',
            id: 'vasterbotten',
            imgUrl: basePath + 'vasterbotten.png'
          },
          {
            region: 'Västernorrland',
            id: 'vasternorrland',
            imgUrl: basePath + 'vasternorrland.png'
          },
          {
            region: 'Västmanland',
            id: 'vastmanland',
            imgUrl: basePath + 'vastmanland.png'
          },
          {
            region: 'Västra Götaland',
            id: 'vastra-gotaland',
            imgUrl: basePath + 'vastra-gotaland.png'
          },
          {
            region: 'Örebro',
            id: 'orebro',
            imgUrl: basePath + 'orebro.png'
          },
          {
            region: 'Östergötland',
            id: 'ostergotland',
            imgUrl: basePath + 'ostergotland.png'
          }
        ]);
      }

      svs.grassroots.app.getRegion().show(new svs.grassroots.views.GrassrootResult({
        model: svs.grassroots.models.grassroot_result,
        collection: svs.grassroots.collections.grassroot_result
      }));
      var regionReqExp = /#(.+)$/;
      var region = regionReqExp.exec(location.href);
      var activeRegion;
      if (region && region.length === 2) {
        activeRegion = decodeURIComponent(region[1]);
        $('#' + activeRegion).click();
      }
    }
  });
})(Backbone, _, svs);


 })(window);